import { unreadCount as styles_unreadCount } from "owa-mail-listitem-styles/lib/scss/MailListItem.scss";
import classnames from "owa-classnames";
import { observer } from "owa-mobx-react";
import { type ConditionalFormattingModification, getConditionalFormattingStyles, ConditionalFormattingSurface, } from "owa-conditional-formatting";
import { useIsTypeRampUpdatesEnabled } from "owa-mail-list-item-shared/lib/utils/useIsTypeRampUpdatesEnabled";
import { useMessageListTextStyle } from "owa-mail-listitem-styles/lib/utils/useMessageListTextStyle";
import React from "react";

export interface MailListItemUnreadCountProps {
    unreadCount: number;
    conditionalFormattingModifications?: ConditionalFormattingModification[];
    isDarkTheme: boolean;
    isSingleLineView?: boolean;
}

const defaultExport: React.FunctionComponent<MailListItemUnreadCountProps> = observer(function MailListItemUnreadCount(props: MailListItemUnreadCountProps): React.JSX.Element | null {
    const { unreadCount, conditionalFormattingModifications, isDarkTheme, isSingleLineView = false, } = props;
    const isTypeRampUpdatesEnabled = useIsTypeRampUpdatesEnabled();
    const majorTextStyle = useMessageListTextStyle("Major");
    const unreadCountConditionalFormattingStyles = React.useMemo(() => {
        const conditionalFormattingStyles = conditionalFormattingModifications && conditionalFormattingModifications.length > 0
            ? getConditionalFormattingStyles(ConditionalFormattingSurface.Text, conditionalFormattingModifications, isDarkTheme)
            : undefined;
        
        return conditionalFormattingStyles;
    }, [conditionalFormattingModifications, isDarkTheme]);
    
    // Under the type ramp the MCV unread count has no explicit font size, so it inherits
    // from the surrounding subject column (tracking the subject size); everywhere else it
    // keeps the Major text style.
    const unreadCountClasses = classnames(styles_unreadCount, !(isSingleLineView && isTypeRampUpdatesEnabled) && majorTextStyle);
    
    return unreadCount > 1 ? (<span className={unreadCountClasses} style={unreadCountConditionalFormattingStyles}>
                ({unreadCount})
            </span>) : null;
}, "MailListItemUnreadCount");
export default defaultExport;
